
export const COST_TYPES = {
    none: "none",
    approved: "approved",
    unapproved: "unapproved"
}


export const COST_TYPE_OPTIONS =  [
    {
        value: COST_TYPES.none,
        label: "Please Select Cost Type"
    },
    {
        value: COST_TYPES.approved,
        label: "Approved"
    },
    {
        value: COST_TYPES.unapproved,
        label: "Draft"
    }
]

